import { setCurrentLocation } from '@/core/redux/currentLocationSlice';
import { RootState } from '@/core/redux/store';
import { getData } from '@/services/api.service';
import {
  appstore,
  cleanclothes,
  googleplay,
  washwave,
} from '@/utils/imagepath';
import { routePrefix } from '@/utils/routes/routes';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
interface PostCodeData {
  postcode: string;
  id?: string;
  [key: string]: any;
}
const BannerSection = ({ themeData }: any) => {
  const settingsData: any = useSelector<any>((state) => state?.settings);
  const headerData = useSelector((state: RootState) => state.common.header);
  const [error, setError] = useState<string>('');
  const [pinCode, setPinCode] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [postCodeList, setPostCodeList] = useState<any[]>([]);
  const [selectedPostCode, setSelectedPostCode] = useState<string>('');

  const handlePostcodeSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!pinCode.trim()) {
      setError('Postcode is required');
      return;
    }

    setIsLoading(true);
    try {
      const response = await getData(`get_shop_by_pincode?pincode=${pinCode}`);

      if (response.status === 200 || response.status === 201) {
        if (response?.data?.success && response?.data?.data?.id) {
          navigate(`${routePrefix}/shop/${response.data.data.id}`);
          dispatch(setCurrentLocation(response.data.data));
        } else {
          setError('No shop found for this postcode');
        }
      }
    } catch (err: any) {
      setError('Area not covered');
    } finally {
      setIsLoading(false);
    }
  };
  const getPostalCode = async () => {
    try {
      const response = await getData(`get_postal_codes?keyword=${pinCode}`);

      if (response.status === 200 || response.status === 201) {
        setPostCodeList(response?.data?.data || []);
      }
    } catch (err) {
      console.error('Failed to fetch postal codes:', err);
      setPostCodeList([]);
    }
  };

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (pinCode && !selectedPostCode) getPostalCode();
    }, 100);

    return () => clearTimeout(debounceTimer);
  }, [pinCode]);

  useEffect(() => {
    if (selectedPostCode) {
      setPinCode(selectedPostCode);
      setPostCodeList([]);
    }
  }, [selectedPostCode]);

  return (
    <>
      <div
        className="banner-section-home-four"
        style={{
          background: `url(${themeData?.theme_4?.home?.section_1?.banner}) no-repeat top center`,
        }}
      >
        <a
          data-bs-toggle="modal"
          data-bs-target="#bannerEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"> </i>
        </a>
        {!settingsData?.WebsiteSettings?.site_title_en.includes(
          'Whiterose'
        ) && (
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-7">
                <div className="banner-search-wrap">
                  <span className="banner-tag">
                    <img src={cleanclothes} alt="" className="me-2" />{' '}
                    {themeData?.theme_4?.home?.section_1?.sub_heading_top}
                  </span>
                  <h1
                    style={{
                      color:
                        themeData?.theme_4?.home?.section_1?.title_color
                          ? `#${themeData.theme_4.home.section_1.title_color}`
                          : '#000000',
                    }}
                  >
                    {themeData?.theme_4?.home?.section_1?.title}
                  </h1>
                  <div className="search-wrapper">
                    <h4
                      style={{
                        color:
                          themeData?.theme_4?.home?.section_1?.paragraph_color
                            ? `#${themeData.theme_4.home.section_1.paragraph_color}`
                            : '#000000',
                      }}
                    >
                      {themeData?.theme_4?.home?.section_1?.paragraph}
                    </h4>
                    {headerData?.postal_code_enabled == '1' && (
                      <div className="postcodeform-container">
                        <form onSubmit={handlePostcodeSubmit}>
                          <div>
                            {error && (
                              <small className="text-danger postvalidation">
                                {error}
                              </small>
                            )}
                            <div className="postcodeform">
                              <input
                                name="pinCode"
                                type="text"
                                id="postcode-input"
                                placeholder={`${themeData?.theme_4?.home?.section_1?.btn_group?.btn1?.placeholder}`}
                                className="ui-autocomplete-input"
                                autoComplete="off"
                                value={pinCode}
                                onChange={(e) => {
                                  setPinCode(e.target.value);
                                  setError('');
                                }}
                              />
                              <button
                                className="btn hover-btn"
                                id="book_now_btn"
                                type="submit"
                                style={{
                                  background: `#${themeData?.theme_4?.home?.section_1?.btn_group?.btn1?.bg_color}`,
                                  color: `#${themeData?.theme_4?.home?.section_1?.btn_group?.btn1?.color}`,
                                }}
                                disabled={isLoading}
                              >
                                {`${themeData?.theme_4?.home?.section_1?.btn_group?.btn1?.text}`}
                              </button>
                              {postCodeList.length > 0 && (
                                <div className="dropdown">
                                  {postCodeList.map((data: PostCodeData) => (
                                    <div
                                      key={data.postcode}
                                      className="dropdown-row"
                                      onClick={() =>
                                        setSelectedPostCode(data.postcode)
                                      }
                                    >
                                      <i className="fas fa-map-marker-alt"></i>
                                      {data.postcode}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                  {/* <SectionOfferSingle /> */}
                </div>
              </div>
              <div className="col-lg-5 d-none d-lg-block">
                <div className="heroimg">
                  {themeData?.theme_4?.home?.section_1?.banner_type ==
                  'image' ? (
                    <img
                      src={themeData?.theme_4?.home?.section_1?.banner_two}
                      alt=""
                      className="img-fluid"
                    />
                  ) : (
                    <>
                      <video
                        loop
                        autoPlay
                        className="img-fluid"
                        src={themeData?.theme_4?.home?.section_1?.banner_two}
                      ></video>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BannerSection;
